var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('display-refund-alert'),_c('div',{attrs:{"id":"sumup-card"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }